module.exports = __webpack_public_path__ + "img/logo_reply.d574a349.svg";